import { tags as t } from "@lezer/highlight"
import { createTheme } from "@uiw/codemirror-themes"

export const snippifyDark = createTheme({
  variant: "dark",
  settings: {
    background: "#212121 !important",
    foreground: "#98f07f !important",
    caret: "#124f48 !important",
    selection: "#036dd626 !important",
    lineHighlight: "#434343 !important",
    gutterBackground: "#212121 !important",
    gutterForeground: "#8a919966 !important",
  },
  styles: [
    {
      tag: t.comment,
      color: "#787b8099 !important",
    },
    {
      tag: t.variableName,
      color: "#f64fa0 !important",
    },
    {
      tag: [t.string, t.special(t.brace)],
      color: "#e19700 !important",
    },
    {
      tag: t.number,
      color: "#0080ff !important",
    },
    {
      tag: t.bool,
      color: "#99ff00 !important",
    },
    {
      tag: t.null,
      color: "#589ee4 !important",
    },
    {
      tag: t.keyword,
      color: "#FFF !important",
    },
    {
      tag: t.operator,
      color: "#718294 !important",
    },
    {
      tag: t.className,
      color: "#0080ff !important",
    },
    {
      tag: t.definition(t.typeName),
      color: "#ffa200 !important",
    },
    {
      tag: t.typeName,
      color: "#28c8fa !important",
    },
    {
      tag: t.angleBracket,
      color: "#00ffcc !important",
    },
    {
      tag: t.tagName,
      color: "#00ffcc !important",
    },
    {
      tag: t.attributeName,
      color: "#ffa200 !important",
    },
  ],
})

export const snippifyLight = createTheme({
  variant: "light",
  settings: {
    background: "#ffffff",
    foreground: "#29bd00",
    caret: "#124f48",
    selection: "#e8d4d4",
    lineHighlight: "#c7c7c7",
    gutterBackground: "#ffffff",
    gutterForeground: "#a9a7a7",
  },
  styles: [
    {
      tag: t.comment,
      color: "#7c7c7c",
    },
    {
      tag: t.variableName,
      color: "#696969",
    },
    {
      tag: [t.string, t.special(t.brace)],
      color: "#84ce83",
    },
    {
      tag: t.number,
      color: "#0196c8",
    },
    {
      tag: t.bool,
      color: "#99ff00",
    },
    {
      tag: t.null,
      color: "#589ee4",
    },
    {
      tag: t.keyword,
      color: "#ff0064",
    },
    {
      tag: t.operator,
      color: "#718294",
    },
    {
      tag: t.className,
      color: "#0080ff",
    },
    {
      tag: t.definition(t.typeName),
      color: "#ffa200",
    },
    {
      tag: t.typeName,
      color: "#008f05",
    },
    {
      tag: t.angleBracket,
      color: "#00a841",
    },
    {
      tag: t.tagName,
      color: "#009e7e",
    },
    {
      tag: t.attributeName,
      color: "#c1018e",
    },
  ],
})

export const simona = createTheme({
  theme: "dark",
  settings: {
    background: "#2f2f2f !important",
    foreground: "#e1dfdf !important",
    caret: "#124f48 !important",
    selection: "#212121 !important",
    lineHighlight: "#8a91991a !important",
    gutterBackground: "#2f2f2f !important",
    gutterForeground: "#8a919966 !important",
  },
  styles: [
    {
      tag: t.comment,
      color: "#787b80",
    },
    {
      tag: t.variableName,
      color: "#f64fa0",
    },
    {
      tag: [t.string, t.special(t.brace)],
      color: "#ed9b1f",
    },
    {
      tag: t.number,
      color: "#0080ff",
    },
    {
      tag: t.bool,
      color: "#99ff00",
    },
    {
      tag: t.null,
      color: "#589ee4",
    },
    {
      tag: t.keyword,
      color: "#b2ff00",
    },
    {
      tag: t.operator,
      color: "#718294",
    },
    {
      tag: t.className,
      color: "#0080ff",
    },
    {
      tag: t.definition(t.typeName),
      color: "#ff462e",
    },
    {
      tag: t.typeName,
      color: "#ed9b1f",
    },
    {
      tag: t.angleBracket,
      color: "red",
    },
    {
      tag: t.tagName,
      color: "#ff462e",
    },
    {
      tag: t.attributeName,
      color: "#ff462e",
    },
  ],
})
